import React, {
  createContext,
  useRef,
  useState,
  useContext,
  useEffect,
} from "react";

const MusicContext = createContext();

export const useMusic = () => useContext(MusicContext);

export const MusicProvider = ({ children }) => {
  const audioRef = useRef(new Audio());
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoop, setIsLoop] = useState(false); // 🔁 حلقه
  const [currentTrack, setCurrentTrack] = useState({});
  const [currentList, setCurrentList] = useState([]);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);




  // وقتی آهنگ عوض میشه
  useEffect(() => {
    const audio = audioRef.current;

    if (!currentTrack.url) return;
    localStorage.setItem("PlayingMusic",JSON.stringify(currentTrack));
    audio.src = currentTrack.url;
    audio.load();

    


    const onLoadedMetadata = () => {
      setDuration(audio.duration);

      if ("mediaSession" in navigator) {
        navigator.mediaSession.metadata = new MediaMetadata({
          title: currentTrack.title || "",
          artist: currentTrack.artist || "",
          album: "",
          artwork: [
            {
              src: currentTrack.cover || "",
              sizes: "512x512",
              type: "image/jpeg",
            },
          ],
        });

        navigator.mediaSession.setActionHandler("play", () => {
          audio.play();
          setIsPlaying(true);
        });

        navigator.mediaSession.setActionHandler("pause", () => {
          audio.pause();
          setIsPlaying(false);
        });

        navigator.mediaSession.setActionHandler("seekto", (details) => {
          if (details.fastSeek && "fastSeek" in audio) {
            audio.fastSeek(details.seekTime);
          } else {
            audio.currentTime = details.seekTime;
          }
        });

        navigator.mediaSession.setActionHandler("previoustrack", playPrevious);
        navigator.mediaSession.setActionHandler("nexttrack", playNext);
      }
    };

    const onEnded = () => {
      if (!isLoop) {
        setIsPlaying(false);
        playNext();
      } // 👈 فقط اگر حالت Loop خاموشه
    };

    audio.addEventListener("loadedmetadata", onLoadedMetadata);
    audio.addEventListener("ended", onEnded);
    setCurrentTime(0);

    return () => {
      audio.removeEventListener("loadedmetadata", onLoadedMetadata);
      audio.removeEventListener("ended", onEnded);
    };
  }, [currentTrack.url]);

  useEffect(() => {
    audioRef.current.loop = isLoop;
  }, [isLoop]);
  // بروز رسانی زمان پخش
  useEffect(() => {

    let value = localStorage.getItem("PlayingMusic");
    if(value){
      console.log(value);
      setCurrentTrack(JSON.parse(value));
    }

    const audio = audioRef.current;
    const update = () => setCurrentTime(audio.currentTime);
    audio.addEventListener("timeupdate", update);

    return () => {
      audio.removeEventListener("timeupdate", update);
    };
  }, []);

  // کنترل پخش / توقف
  useEffect(() => {
    const audio = audioRef.current;
    if (!currentTrack.url) return;

    if (isPlaying) {
      audio.play().catch(() => {});
    } else {
      audio.pause();
    }
  }, [isPlaying, currentTrack.url]);

  // پخش آهنگ بعدی
  const playNext = () => {
    const currentIndex = currentList.findIndex(
      (item) => item.songUrl === currentTrack.url
    );
    if (currentIndex !== -1 && currentIndex < currentList.length - 1) {
      const next = currentList[currentIndex + 1];
      setCurrentTrack({
        title: next.artist,
        artist: next.artist,
        cover: next.cover,
        url: next.songUrl,
        duration: 0,
      });
      setIsPlaying(true);
    }
  };

  // پخش آهنگ قبلی
  const playPrevious = () => {
    const currentIndex = currentList.findIndex(
      (item) => item.songUrl === currentTrack.url
    );
    if (currentIndex > 0) {
      const previous = currentList[currentIndex - 1];
      setCurrentTrack({
        title: previous.artist,
        artist: previous.artist,
        cover: previous.cover,
        url: previous.songUrl,
        duration: 0,
      });
      setIsPlaying(true);
    }
  };

  // پخش آهنگ تصادفی
  const playRandom = () => {
    if (currentList.length === 0) return;

    const randomIndex = Math.floor(Math.random() * currentList.length);
    const randomTrack = currentList[randomIndex];

    setCurrentTrack({
      title: randomTrack.artist,
      artist: randomTrack.artist,
      cover: randomTrack.cover,
      url: randomTrack.songUrl,
      duration: 0,
    });
    setIsPlaying(true);
  };

  const value = {
    audioRef,
    isPlaying,
    setIsPlaying,
    isLoop,
    setIsLoop, // برای کنترل تکرار از بیرون
    currentTime,
    setCurrentTime,
    duration,
    currentTrack,
    setCurrentTrack,
    currentList,
    setCurrentList,
    playNext,
    playPrevious,
    playRandom, // تابع جدید
  };

  return (
    <MusicContext.Provider value={value}>{children}</MusicContext.Provider>
  );
};
